module.exports = __webpack_public_path__ + "img/facebook_icon.273b7cc3.svg";